/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} 

Start styles for component here
Your Styles goes here  
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

*/
const CpdsProgressBarStyleTag = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      width: 100%;
      height: 2px;
      background-color: ${token?.progress_bar_background_color};
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const CpdsProgressBarSeekerStyleTag = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      width: ${props?.progress || '0'}%;
      height: 100%;
      background-color: ${token?.progress_bar_seeker_color};
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export { CpdsProgressBarStyleTag, CpdsProgressBarSeekerStyleTag };
